import * as React from "react";
import * as _ from "lodash";
import {ICustomHeaderInfo} from "../../utils/CustomHeader";

const headers: ICustomHeaderInfo[] = [
    {label: "goal", display: "Goal", value: "Goal"},
    {label: "metric", display: "Metric", value: "Metric"},
    {label: "current", display: "Current", value: "Current"},
    {label: "target", display: "Target", value: "Target"}
]

interface GoalsPdfProps {
    goals: any[]
}

export default class GoalsPdf extends React.Component<GoalsPdfProps> {

    render () {
        const pdfGoals = _.groupBy(this.props.goals, (goalItem: any) => goalItem.goalName);
        return (
            <div className={"pdf-table"}>
                <div className={"pdf-table-row header-row medium-text"}>
                    {
                        _.map(headers, (headerItem: ICustomHeaderInfo, index: number) => {
                            return (
                                <div className={"pdf-table-col"} key={`${headerItem.display}-${index}`}>
                                    <div className={"col-header brandon-bold"}>{headerItem.display}</div>
                                </div>
                            )
                        })
                    }
                </div>
                <div id="primaryGoals-subsection" className={"pdf-table-body"}>
                    {
                        !_.isEmpty(pdfGoals) && _.map(pdfGoals, (item: any, key: string) => {
                            return _.map(item, (goal: any, index: number) => {
                                return (<div className={"pdf-table-row"} key={`goal-row-${index}`}>
                                    <div className={"pdf-table-col brandon-bold"}>{index === 0 ? key : ""}</div>
                                    <div className={"pdf-table-col"}>{goal.metric}</div>
                                    <div className={"pdf-table-col"}>{goal.current}</div>
                                    <div className={"pdf-table-col"}>{goal.target}</div>
                                </div>)
                            })
                        })
                    }
                </div>
            </div>
        );
    }
}